/**
 * Dorado's BPAY biller code. The settlement line on the main account quotes it,
 * and the BRF reports NAB drops are named after it (see server/src/bpay/config.ts).
 */
export const BPAY_BILLER_CODE = "355255"

/**
 * Identifies the daily BPAY settlement credit on the main account — the row the
 * BPAY reconciliation pivots off, whose amount should equal that date's BPAY
 * transactions and which must therefore be excluded from the main account's own
 * totals.
 *
 * NAB has narrated it three ways, and rows of every vintage are still on the
 * account:
 *
 *     MISCELLANEOUS CREDIT TOTAL BILL PAYMENT - BILLER 0000355255
 *     TOTAL BILL PAYMENT - BILLER 0000355255
 *     FLEXIPHONE-BILL PAY TOTAL BILL PAYMENT - BILLER 0000355255   (BAI2)
 *
 * BAI2 builds the narration from the transaction's text field joined to any
 * continuation records, so the channel prefix and the spacing between the parts
 * are NAB's to keep changing. "TOTAL BILL PAYMENT" is the part that has survived
 * every change, so match on that, and where the narration does name a biller,
 * require it to be ours.
 *
 * Narration is coerced rather than assumed to be a string: some stored rows hold
 * a number.
 */
export function isBpayTotalBillPayment(narration: unknown): boolean {
    const normalized = String(narration ?? "").toUpperCase().replace(/\s+/g, " ")
    if (!normalized.includes("TOTAL BILL PAYMENT")) return false
    const biller = /BILLER\s*(\d+)/.exec(normalized)
    return !biller || biller[1].replace(/^0+/, "") === BPAY_BILLER_CODE
}
